import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import * as Sentry from "@sentry/react";
import { store } from './store'
import Hotjar from "@hotjar/browser";
import '@progress/kendo-theme-default/dist/all.css'
import '@assets/css/index.css'
import App from './App.tsx'


import { initDeploymentDetector } from "@utils/blitzDeploymentDetector";
import "./auth/amplifyConfig";

// -----------------------------------------------------
// Initialize Deployment Detector BEFORE anything else
// -----------------------------------------------------
initDeploymentDetector();   // <--- Added here

const rawEnv = (import.meta.env.VITE_APP_ENVIRONMENT as string | undefined) ?? "";
const SENTRY_ENABLED = Boolean(rawEnv.trim());

const siteId = import.meta.env.VITE_HOTJAR_SITE_ID;
const hotjarVersion = import.meta.env.VITE_HOTJAR_VERSION;

Hotjar.init(siteId, hotjarVersion);

if (SENTRY_ENABLED) {
  Sentry.init({
    dsn: "https://4385ac9345687147a68ebaa3ffe83114@o4510148058742784.ingest.de.sentry.io/4510153902784592",
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration()
    ],
    tracesSampleRate: 1.0,
    enableLogs: true,
    environment: import.meta.env.VITE_APP_ENVIRONMENT ?? "Unknown",

    beforeSend(event) {
      if (event?.message?.includes("Websocket close was unclean: 1006")) {
        return null;
      }
      return event;
    }
  });
} else {
  console.info("Sentry disabled: missing VITE_APP_ENVIRONMENT");
}

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <App />
  </Provider>,
)